<script lang="ts" setup>
  import { storeToRefs } from 'pinia';

  import { type Partner } from '~/types/ecommerce/generated.codegen';

  defineProps<{
    user: Partner;
  }>();

  const userStore = useUserStore();
  const { inPersonification } = storeToRefs(userStore);

  const finishPersonification = () => {
    userStore.removePersonifiedUser();
  };
</script>

<template>
  <div v-if="inPersonification && user.tradingName" class="impersonate-alert">
    <SolAlert
      id="impersonate-alert"
      feedback="informative"
      action="Encerrar personificação"
      :title="`Visualizando como o parceiro ${user.tradingName || ''} ${user.cnpj || ''}`"
      text="Todas as ações que você fizer a partir de agora afetarão este parceiro."
      @click="finishPersonification" />
  </div>
</template>

<style lang="scss">
  @mixin site-container {
    @apply w-full md:site:max-w-[1440px];
    @apply md:site:mx-auto;
  }
  .impersonate-alert {
    @apply py-4xs;
    @include site-container;
  }
</style>
